import { takeEvery, put, select } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

import { accountGroupsSagas } from 'companion-app-components/flux/account-groups';
import * as actions from 'companion-app-components/flux/account-groups/accountGroupsActions';
import { 
  getAccountGroups, 
  getCurrentAccountGroupName, 
  selectSharedAccountGroup, 
} from 'companion-app-components/flux/account-groups/accountGroupsSelectors';
import { 
  getDefaultAccountGroupName, 
  hasFullDatasetAccess, 
} from 'companion-app-components/flux/account-groups/accountGroupUtils';
import { getCurrentDataset } from 'companion-app-components/flux/auth/authSelectors';
import { Dataset } from 'companion-app-components/flux/datasets/datasetsTypes';
import { 
  ALL_ACCOUNT_GROUPS, 
  LS_KEY_SELECTED_ENTITY, 
  UN_ASSIGNED_ACCOUNTS, 
} from 'companion-app-components/flux/account-groups/accountGroupsTypes';

function* getAccountGroupsSuccessWatcher() {
  yield takeEvery(actions.getAccountGroupsSuccess, function* handlegetAccountGroupsSuccess(): SagaIterator {
    const selectedGroupName: string = yield select(getCurrentAccountGroupName);
    const dataset: Dataset = yield select(getCurrentDataset);
    const sharedAccountGroups = yield select(selectSharedAccountGroup);
    const allAccountGroups = yield select(getAccountGroups);

    const savedEntityInLS = localStorage.getItem(LS_KEY_SELECTED_ENTITY);
    const accountGroups = dataset?.shared ? sharedAccountGroups : allAccountGroups;
    const predefinedGroups = [ALL_ACCOUNT_GROUPS, UN_ASSIGNED_ACCOUNTS];

    const selectedEntityName = accountGroups?.find(({ id }) => savedEntityInLS === id)?.name || '';
    let nextSelectedGroupName: string;

    if (selectedEntityName) {
      nextSelectedGroupName = selectedEntityName;
    } else if (
      savedEntityInLS &&
      (!dataset?.shared || hasFullDatasetAccess(dataset)) &&
      predefinedGroups.includes(savedEntityInLS)
    ) {
      nextSelectedGroupName = savedEntityInLS;
    } else {
      // Check user has access to the selected group
      const hasSelectedGroupName = accountGroups?.find(({ name }) => selectedGroupName === name);
      if (hasSelectedGroupName) {
        nextSelectedGroupName = selectedGroupName;
      } else {
        nextSelectedGroupName = getDefaultAccountGroupName(accountGroups, dataset);
      }
    }

    if (nextSelectedGroupName) {
      yield put(actions.selectAccountGroup(nextSelectedGroupName));
    }
  });
}

export default [
  ...accountGroupsSagas,
  getAccountGroupsSuccessWatcher,
];
